import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X6PageStore} from '../X6PageStore';

@observer
export class DeletePushableBlockControls extends React.Component<{ store: X6PageStore }> {
  render() {
    const {store} = this.props;

    if (store.deletePushableBlock === null)
      return null;

    const deletePushableBlock = store.deletePushableBlock;
    const isFailure = deletePushableBlock.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting" state={deletePushableBlock.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end" key="delete-actions">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDelete(deletePushableBlock.pushableBlockId)}>
              Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}>
              Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
